import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { WebhookBodyNotSet } from './WebhookBodyNotSet';

const JsonBodyText = styled.pre`
  color: ${colors.textSecondary};
  background: ${colors.grey1};
  border: ${spacing.single} solid ${colors.grey15};
  box-sizing: border-box;
  border-radius: ${spacing.quarter};
  white-space: pre-wrap;
`;

export const JsonBody = ({ body }) => {
  if (!body) {
    return <WebhookBodyNotSet />;
  }

  const jsonText = typeof body === 'string' ? body : JSON.stringify(body, null, 4);
  return <JsonBodyText>{jsonText}</JsonBodyText>;
};
